import { Button, Typography } from '@mui/material';
import React from 'react'





// WaterIntakeAdd.jsx
const WaterIntakeAdd = ({ closeModalAndRefresh, values }) => {
    return (
        <div>
            {/* Your component JSX */}
            <Typography variant="body1">Water Intake Component</Typography>
            <Button onClick={closeModalAndRefresh}>Close</Button>
        </div>
    );
};

export default WaterIntakeAdd;
